<template>
  <div class="search-container">
    <div class="search-tabs">
      <div
        class="search-tab"
        v-for="item in options"
        :key="item.value"
        :class="{ active: value === item.value }"
        @click="searchChange(item.value)"
      >
        <span>{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { value: { type: String, default: '' } },
  computed: {
    options() {
      return [
        {
          label: this.$l('tabs_label_isAllShipments_N') || '未出完',
          value: 'N',
        },
        {
          label: this.$l('tabs_label_isAllShipments_Y') || '已出完',
          value: 'Y',
        },
        { label: this.$l('tabs_label_isAllShipments_ALL') || '全部', value: '' },
      ]
    },
  },
  methods: {
    searchChange(value) {
      this.$emit('update:value', value)
      this.$emit('input', value)
      this.$emit('change', value)
    },
  },
}
</script>
<style lang="scss" scoped>
.search-container {
  .search-tabs {
    display: flex;
    align-items: center;
    .search-tab {
      font-size: 14px;
      line-height: 28px;
      padding: 0px 12px;
      color: #2e2e2e;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      width: max-content;
      .badge {
        margin-left: 5px;
        font-weight: 400;
        color: #707070;
        background-color: rgba(0, 0, 0, 0.07);
        padding: 3px 7px;
        font-size: 12px;
        border-radius: 10px;
      }
    }
    .search-tab:hover {
      color: #000;
      border-bottom-color: rgba(0, 0, 0, 0.1);
    }
    .search-tab.active {
      color: #000;
      font-weight: 600;
      border-bottom-color: $color-success;
      .badge {
        font-weight: 600;
      }
    }
  }
}
</style>
